export default "__VITE_ASSET__C5vgkb5s__"